import { normalizeNumbers } from './utils'

type CreditCardDTOData = FormIndustryRechargeCreditCard

export const creditCardDTO = (
  data: CreditCardDTOData
): IndustryRechargeCreditCard => {
  // Se houver token (MercadoPago), retornar apenas o token e brand
  if (data.card_token) {
    return { card_token: data.card_token, brand: data.card_brand }
  }

  // Provider default: retornar dados do cartão
  const [mm, yy] = (data.card_expiration || '').split('/')
  return {
    brand: data.card_brand || '',
    expiration_date: `${mm}/20${yy}`,
    holder_name: data.card_name || '',
    number: normalizeNumbers(data.card_number || ''),
    security_code: data.card_cvv || ''
  }
}
